<template>
  <div class="about">
    <div class="container banner">
      <img src="../../static/img/about/banner.png" class="top-banner" alt="">
      <div class="content">
        <div class="bread">
          您现在的位置：
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{path:'/dynamic'}">最新动态</el-breadcrumb-item>
            <el-breadcrumb-item>月子科普</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="about-title">
          <h3 class="meal-title">{{article.name}}
          </h3>
          <p class="sub-title">
            日期: {{article.date}} &nbsp;&nbsp;
            查看： {{article.check}}
          </p>
        </div>
        <div class="about-article" v-html="article.content">

        </div>
        <div class="rec-article">
          <p class="rec-title">推荐文章</p>
          <ul>
            <li class="rec-item" v-for="item in recList" @click="jumpTo(item.id)">
                <p>{{item.name}}</p>
                <span class="date">2020 - 04 - 23</span>
            </li>

            <div style="clear: both"></div>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Daily from '../assets/data/dynamic';

  export default {
    name: "dynamicDetail",
    data(){
      return{
        id:null,
        article: [],
        recList:[
          {
            id:'a-1',
            name:'在台式月子会所坐月子的优势有哪些',
            content:'在这个科学的时代中，大家都认为在台式月子会所能够享用到更科学合理的护理。服务较好的台式月子会所能使大家得到身体需求的充沛调养',
            picUrl:'../../static/img/dynamic/dy-2.png'
          },
          {
            id:'a-2',
            name:'产后修复不盲目丨认识它，才能选对它',
            content:'在这个科学的时代中，大家都认为在台式月子会所能够享用到更科学合理的护理。',
            picUrl:'../../static/img/dynamic/list/1.jpg'
          },
          {
            id:"b-1",
            name:'关于“专业”我们是认真的！',
            content:'在这个科学的时代中，大家都认为在台式月子会所能够享用到更科学合理的护理。服务较好的台式月子会所能使大家得到身体需求的充沛调养',
            picUrl:'../../static/img/dynamic/00.jpg'
          },
          {
            id:"c-1",
            name:'合美月子中心周年庆',
            content:'在这个科学的时代中，大家都认为在台式月子会所能够享用到更科学合理的护理。服务较好的台式月子会所能使大家得到身体需求的充沛调养',
            picUrl:'../../static/img/dynamic/dy-5.jpg'
          },
        ]
      }
    },
    created() {
      this.filterKind()
    },
    methods:{
      jumpTo:function(id){
        var that = this;
        this.id = id;
        switch (this.id[0]) {
          case 'a':
            var data = Daily.article;
            break;
          case 'b':
            var data = Daily.dynamic;
            break
          case 'c':
            var data = Daily.active;
            break
        }
        for(var i=0;i<data.length;i++){
          if(data[i].id == that.id){
            this.article = data[i]
          }
        }
      },
      filterKind:function () {
        var that = this;
        this.id = this.$route.params.id;
        switch (this.id[0]) {
          case 'a':
            var data = Daily.article;
            break;
          case 'b':
            var data = Daily.dynamic;
            break
          case 'c':
            var data = Daily.active;
            break
        }
        for(var i=0;i<data.length;i++){
          if(data[i].id == that.id){
            this.article = data[i]
          }
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .about{
    .banner{
      .top-banner{
        width: 100%;
        margin-bottom: 20px;
      }
      .bread{
        margin-bottom: 20px;
        font-size: 12px;
        color:#999999;
        .el-breadcrumb{
          vertical-align: middle;
          display: inline-block;
          span{
            font-size: 12px;
            color:#999999;
          }
        }
      }
      .about-title{
        margin-bottom: 32px;
      }
      .about-article{
        margin-bottom: 50px;
        .text{
          font-size: 14px;
          line-height: 28px;
          color:#666666;
        }
        .title{
          font-weight: 600;
          font-size: 14px;
          line-height: 28px;
          color: #333333;
        }
        img{
          width: 40%!important;
          display: block;
          margin:30px auto ;
        }
      }
      .rec-article{
        margin-bottom: 50px;
        width: 100%;
        .rec-title{
          font-size: 16px;
          line-height: 32px;
          margin-bottom: 12px;
        }
        .rec-item{
          cursor: pointer;
          float: left;
          width: 40%;
          padding-right: 60px;
          margin-bottom: 6px;
          .in-rec{
            display: block;
            width: 338px;
          }
          p{
            width: 200px;
            color: #666666;
            overflow: hidden;
            white-space: nowrap;
            text-overflow:ellipsis;
            display: inline-block;
          }
          .date{
            color: #cccccc;
            float: right;
          }
        }
      }
    }
  }
  .meal-title{
    margin-bottom: 8px;
    text-align: center;
    font-size: 28px;
    line-height: 32px;
    font-weight: 500;
    .title-line{
      width: 65px;
      height: 1px;
      margin:0 30px;
      display: inline-block;
      background-color: #cccccc;
      vertical-align: middle;
    }
  }
  .sub-title{
    color:#b3b3ba;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/components/dynamicDetail.vue